import clsx from 'clsx';
import { ReactNode } from 'react';

export default function Card({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={clsx(
        'w-full px-[24px] py-[26px] bg-white shadow-card rounded-[12px] border border-primary-100',
        className
      )}
    >
      {children}
    </div>
  );
}
